
    import { toRefs } from 'vue';
    import { ScaleControl } from 'mapbox-gl';
    import MapLegend from '@/components/main/MapLegend.vue';
    import Pegman from './Pegman.vue'
    const TOOLBAR_WIDTH = 48; // Also change the translate of #tbdc-bottomtoolbar

    export default {
        components: {
            MapLegend,
            Pegman
        },

        data: () => ({
            model: null
        }),

        setup(props) {
            let { mapValue, scaleControlValue } = toRefs(props);
            let map = null;
            if (mapValue.value.map) { // When we get a MapBox compenent reference
                map = mapValue.value.map;
            } else {
                map = mapValue;
            }
            let scaleControl: ScaleControl = scaleControlValue.value;

            return {
                map,
                scaleControl
            }
        },

        mounted() {
            this.pegmanElement = document.getElementById('pegman');
            this.bottomToolbarElement = document.getElementById('tbdc-bottomtoolbar');
            // Setup pegman UI location
            this.updateFooter();
            this.setMapEvents();
        },

        methods: {
            setMapEvents() {
                this.map.on('zoom', () => { // Scalebar moves when zooming
                    this.updateFooter();
                })
                this.map.on('move', () => { // Scalebar moves when moving the map
                    this.updateFooter();
                });
            },

            updateFooter() { // Update the style of the bottom toolbar to allign witht the scalebar
                const pegman: HTMLElement = this.pegmanElement as HTMLElement;
                const toolbar: HTMLElement = this.bottomToolbarElement as HTMLElement;
                if (!pegman || !toolbar) return;

                const scaleControlWidth = this.scaleControl._container.offsetWidth;
                const pegmanWidth = pegman.offsetWidth;
                toolbar.style.width = `${scaleControlWidth + pegmanWidth + TOOLBAR_WIDTH}px`;
            }
        },


        watch: {
            mapValue(next) {
                this.map = next;
                this.setMapEvents();
            },

            scaleControlValue(next: ScaleControl) {
                this.scaleControl = next;
            },
        },

        
        props: {
            mapValue: {
                type: Object,
                required: true
            },
            scaleControlValue: {
                type: ScaleControl,
                required: true
            },
            legendData: {
                type: Array,
                required: false
            }
        }
    }
